import { nairobiGateway } from './fetch';

const bodyElement = document.querySelector('body');

const defaultScripts = [
  `${nairobiGateway}/accessmngapi/provider/accessmanagement.js`,
  `${nairobiGateway}/nairobiapi/provider/nairobiprovider.js`,
  `${nairobiGateway}/contentapi/provider/ContentProvider.js`,
];

export const loadScripts = async (scripts = defaultScripts) => {
  return new Promise((resolve, reject) => {
    let scriptLoadedCount = 0;
    if (scripts) {
      function checkCounter() {
        if (scriptLoadedCount === scripts.length) {
          resolve();
        }
      }

      scripts.forEach((script) => {
        const scriptTag = document.createElement('script');
        scriptTag.type = 'text/javascript';

        scriptTag.onerror = (error) => {
          scriptLoadedCount++;
          checkCounter();
        };
        scriptTag.onload = () => {
          scriptLoadedCount++;
          checkCounter();
        };

        scriptTag.src = script;

        bodyElement.appendChild(scriptTag);
      });
    } else {
      resolve();
    }
  });
};
